import I18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// eslint-disable-next-line react-hooks/rules-of-hooks
export const i18n = I18n.use(initReactI18next);
